<header id="main-header" class="w-full bg-white select-none">
    <section
        class="flex justify-between items-center px-4 py-3 w-full bg-white border-b border-gray-200 xl:container xl:mx-auto xl:border-none xl:py-2.5 xl:px-0"
    >
        <img
            [draggable]="false"
            class="h-full max-h-6 transition-all duration-300 ease-in-out cursor-pointer xl:my-1 xl:h-full xl:max-h-8 hover:opacity-70"
            routerLink="/schedule"
            src="logo.svg"
            alt="logo"
        />
        <div class="flex gap-3 justify-center items-center">
            @if (user(); as user) {
                <app-select-center />
                <button class="flex items-center gap-3 xl:hidden">
                    <div class="relative" routerLink="/my-page/notification">
                        @if (notificationCount(); as count) {
                            <div
                                class="text-xs absolute rounded-full size-[18px] flex items-center justify-center bg-primary text-white -top-1 -right-2"
                            >
                                {{ count }}
                            </div>
                        }
                        <app-icon
                            name="solar:bell-bold-duotone"
                            class="text-gray-500 !size-7"
                        />
                    </div>

                    <div class="relative" routerLink="/shopping-cart">
                        @if (
                            user?.shoppingCart &&
                                user?.shoppingCart?.itemsCount;
                            as count
                        ) {
                            <div
                                class="text-xs absolute rounded-full size-[18px] flex items-center justify-center bg-primary text-white -top-1 -right-2"
                            >
                                {{ count }}
                            </div>
                        }
                        <app-icon
                            name="solar:bag-4-bold-duotone"
                            class="text-gray-500 !size-7"
                        />
                    </div>

                    <app-icon
                        (click)="openSidemenu()"
                        name="material-symbols:menu-rounded"
                        class="text-gray-500 !size-7"
                    />
                </button>
            }
            <div class="hidden gap-5 justify-center items-center xl:flex">
                @if (user(); as user) {
                    <div
                        class="flex gap-1 items-center transition-all duration-300 ease-in-out cursor-pointer select-none hover:opacity-80"
                        [cdkMenuTriggerFor]="myPageMenu"
                    >
                        <app-icon
                            name="solar:user-circle-bold-duotone"
                            class="text-gray-500"
                            size="md"
                        />

                        <span class="text-sm font-normal text-gray-500 shrink-0"
                            >{{ user.name || user.auth.email }} 님</span
                        >
                    </div>
                    <a
                        (click)="logout()"
                        class="flex gap-1 items-center transition-all duration-300 ease-in-out cursor-pointer select-none hover:opacity-80"
                    >
                        <app-icon
                            name="solar:logout-2-bold-duotone"
                            class="text-gray-500"
                            size="md"
                        />

                        <span class="text-sm font-normal text-gray-500">
                            로그아웃</span
                        >
                    </a>
                    <button class="flex gap-3 items-center">
                        <div
                            class="relative"
                            routerLink="/my-page/notification"
                        >
                            @if (notificationCount(); as count) {
                                <div
                                    class="text-xs absolute rounded-full size-[18px] flex items-center justify-center bg-primary text-white -top-1 -right-2"
                                >
                                    {{ count }}
                                </div>
                            }
                            <app-icon
                                name="solar:bell-bold-duotone"
                                class="text-gray-500"
                                size="lg"
                            />
                        </div>

                        @if (!isNativeApp()) {
                            <div class="relative" routerLink="/shopping-cart">
                                @if (user?.shoppingCart?.itemsCount; as count) {
                                    <div
                                        class="text-xs absolute rounded-full size-[18px] flex items-center justify-center bg-primary text-white -top-1 -right-2"
                                    >
                                        {{ count }}
                                    </div>
                                }
                                <app-icon
                                    name="solar:bag-4-bold-duotone"
                                    class="text-gray-500"
                                    size="lg"
                                />
                            </div>
                        }
                    </button>
                } @else {
                    <a
                        routerLink="/login"
                        class="flex gap-1 items-center transition-all duration-300 ease-in-out cursor-pointer select-none hover:opacity-80"
                    >
                        <app-icon
                            name="solar:login-2-bold-duotone"
                            class="text-gray-500"
                            size="md"
                        />
                        <span class="text-sm font-normal text-gray-500">
                            로그인</span
                        >
                    </a>
                }
                <!-- <button
          routerLink="subscription"
          class="flex gap-1 items-center px-3 py-2 rounded-lg transition-all duration-300 ease-in-out hover:opacity-80"
          style="
            background: linear-gradient(
              270deg,
              #1693c9 0%,
              #4f5cef 63.36%,
              #6c4fef 92.5%
            );
          "
        >
          <img
            src="malirang-white.svg"
            class="w-full h-full max-h-4 max-w-14"
            alt="malirang white logo"
          />
          <span class="text-sm text-white">구독권/이용권</span>
        </button> -->
            </div>
        </div>
    </section>
</header>

<ng-template #myPageMenu>
    @if (user(); as user) {
        <div
            cdkMenu
            class="flex flex-col gap-4 p-4 my-[22px] bg-white rounded-xl shadow-lg"
            style="width: 268px"
        >
            <div class="flex flex-col gap-2">
                <div class="flex gap-1 items-center">
                    <p class="font-bold text-gray-800">
                        {{ user.name }} 선생님
                    </p>
                    <app-center-role-badge />
                </div>
                <p class="text-xs text-gray-400">{{ user.auths[0].email }}</p>
            </div>
            <div class="w-full border-b border-gray-100"></div>

            <div class="flex flex-col gap-1">
                @for (item of menuItems; track item.url) {
                    <button
                        cdkMenuItem
                        [routerLink]="item.url"
                        class="item-button"
                    >
                        <div class="flex gap-2 items-center">
                            <app-icon
                                routerLinkActive="text-primary"
                                [name]="item.icon"
                                class="text-gray-500"
                            />
                            <p routerLinkActive="text-primary">
                                {{ item.label }}
                            </p>
                        </div>

                        <app-icon
                            name="material-symbols:arrow-forward-ios"
                            routerLinkActive="text-primary "
                            class="text-gray-300 cursor-pointer"
                            size="sm"
                        />
                    </button>
                }
            </div>
        </div>
    }
</ng-template>
